import React from "react";
import { format } from "date-fns";

import { dateFormatMonth } from "../../constants/app-constants";
import { getCategoryStatus } from "../Common/ListOfInfoPortalStatus";

class CategoryView extends React.Component {
  render() {
    const {
      id,
      name,
      description,
      manager,
      client,
      projectId,
      displayOrder,
      status,
      viewByAllUsers,
      createdBy,
      createdOn,
      lastModifiedBy,
      lastModifiedOn,
      
    } = this.props.category;
    const statusOptions = getCategoryStatus(status);
    return (
      <>
        <h1 className="heading m-b-25">Project Details - {id}</h1>
        {id ? (
          <div className="row">
            <div className="col-md-12">
              <div className="box-card" style={{ height: "250px" }}>
                <div className="row">
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Name</label>
                      <div className="form-control-plaintext word-break">{name}</div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Project Id</label>
                      <div className="form-control-plaintext word-break">{projectId}</div>
                    </div>
                  </div>
                </div>
                <div className="row">
                <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Client</label>
                      <div className="form-control-plaintext word-break">{client}</div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Manager</label>
                      <div className="form-control-plaintext word-break">{manager}</div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <div className="form-group">
                      <label>Description</label>
                      <div className="form-control-plaintext word-break">{description}</div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Created By </label>
                      <div className="form-control-plaintext word-break">{
                          createdBy && createdBy.loginId
                            ? createdBy.loginId
                            : ""
                        }</div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Created On</label>
                      <div className="form-control-plaintext word-break">{
                          createdOn ? format(createdOn, dateFormatMonth) : ""
                        }</div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Last Modified By</label>
                      <div className="form-control-plaintext word-break">{
                          lastModifiedBy && lastModifiedBy.loginId
                            ? lastModifiedBy.loginId
                            : ""
                        }</div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-group">
                      <label>Last Modified On </label>
                      <div className="form-control-plaintext word-break">{
                          lastModifiedOn
                            ? format(lastModifiedOn, dateFormatMonth)
                            : ""
                        }</div>
                    </div>
                  </div>
                </div>

                {/* <div className="row">
                  <div className="col-md-5">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={this.props.toggleEditMode}
                    >
                      Edit
                    </button>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="col-md-3">
              <div className="box-card" style={{ height: "250px" }}>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <label>Status</label>
                      <div className="form-control-plaintext word-break">{
                          statusOptions
                            ? statusOptions[0].name
                            : ""
                        }</div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <label>Display Order</label>
                      <div className="form-control-plaintext word-break">{
                          displayOrder
                            ? displayOrder
                            : ""
                        }</div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <div className="form-group">
                      <label>View By All : </label>
                      <input type="checkbox" checked={viewByAllUsers} style={{marginLeft: '3px', width: '15px', height: '15px'}}/>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        ) : null}
      </>
    );
  }
}

export default CategoryView;
